export default (state = 0, action = {}) => {
    if (action.type === 'TEST_SERIES_INDEX') {
        return action.payload;
    }
    return state;
}